import { NOT_ASSIGNED_LABEL, NOT_ASSIGNED_RAW_ID } from "./constants";
import { EntitySelectionType } from "./types";
import type { EntityRowNode } from "./types";

export const isNotAssignedGroupNode = (node: EntityRowNode): boolean => {
  if (!node.group) {
    return false;
  }
  return (
    node.data?.billingGroupName === NOT_ASSIGNED_LABEL ||
    node.key === NOT_ASSIGNED_LABEL ||
    node.data?.billingGroupId === NOT_ASSIGNED_RAW_ID ||
    node.key === NOT_ASSIGNED_RAW_ID
  );
};

export const filterNotAssignedGroup = (nodes: EntityRowNode[]): EntityRowNode[] =>
  nodes.filter((node) => !isNotAssignedGroupNode(node));

const isUnassignedEntity = (node: EntityRowNode): boolean =>
  !node.group && node.data?.billingGroupId === NOT_ASSIGNED_RAW_ID;

export const getSelectionType = (selectedNodes: EntityRowNode[]): EntitySelectionType => {
  if (selectedNodes.length === 0) {
    return EntitySelectionType.None;
  }

  const groupNodes = selectedNodes.filter((node) => node.group);
  const leafNodes = selectedNodes.filter((node) => !node.group);

  if (groupNodes.length > 0 && leafNodes.length === 0) {
    return EntitySelectionType.BillingGroup;
  }

  if (leafNodes.length > 0 && groupNodes.length === 0) {
    if (leafNodes.every((node) => isUnassignedEntity(node))) {
      return EntitySelectionType.UnassignedEntity;
    }
    return EntitySelectionType.AssignedEntity;
  }

  return EntitySelectionType.None;
};

export const getRowSelectability = (
  category: EntitySelectionType,
  node: EntityRowNode,
  selectedBillingGroupId?: string | null,
): boolean => {
  if (category === EntitySelectionType.None) {
    return true;
  }

  if (category === EntitySelectionType.UnassignedEntity) {
    if (node.group) {
      return isNotAssignedGroupNode(node);
    }
    return isUnassignedEntity(node);
  }

  if (category === EntitySelectionType.AssignedEntity) {
    if (node.group) {
      return false;
    }
    if (!isUnassignedEntity(node)) {
      if (selectedBillingGroupId !== undefined && selectedBillingGroupId !== null) {
        return node.data?.billingGroupId === selectedBillingGroupId;
      }
      return true;
    }
    return false;
  }

  if (category === EntitySelectionType.BillingGroup) {
    if (!node.group) {
      return false;
    }
    if (isNotAssignedGroupNode(node)) {
      return false;
    }
    if (selectedBillingGroupId) {
      return node.data?.billingGroupId === selectedBillingGroupId;
    }
    return true;
  }

  return true;
};

export const getEntitySelectionCount = (selectedNodes: EntityRowNode[]): number =>
  selectedNodes.filter((node) => !node.group).length;

export const getGroupSelectionCount = (selectedNodes: EntityRowNode[]): number =>
  selectedNodes.filter((node) => node.group).length;
